import React from 'react';
import { Button, Alert, Popover, Modal, ModalHeader, ModalFooter, ModalBody, Row, Col, FormGroup, Input, Label, Progress, InputGroup, UncontrolledTooltip } from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux'
import ValidatedTextBox from '../ValidatedTextBox';
import { Flag } from 'flagger/react';
import { CircularProgress } from '@mui/material';;

class EditPollingServiceModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: '',
            service: {},
            documentTypes: [],
            folders: [],
            pollerType: '',
            isLoading: false,
            folder: '',
            submitted: false
        }
    }

    componentDidMount = () => {
        this.formIsLoading();
        this.getPollerService();
        this.getX3Folders();
        this.getDocumentTypes();
    }

    formIsLoading() {
        this.setState({ isLoading: true });
    }

    getPollerService = () => {
        if (this.props.type == 'mailbox') {
            fetch('/api/poller/inbox?id=' + this.props.destination)
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            service: result,
                            isLoading: false,
                            pollerType: this.props.type
                        })

                    })
                .catch(error => {
                    alert(JSON.stringify(error));
                });
        } else {
            fetch('/api/poller/directory?id=' + this.props.destination)
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            service: result,
                            isLoading: false,
                            pollerType: this.props.type
                        })
                    })
                .catch(error => {
                    alert(JSON.stringify(error));
                });
        }
    }

    isFormValid = () => {
        const { service } = this.state;
        const type = this.props.type;
        if (!service.name) return false;
        if (!service.description) return false;
        if (type === 'mailbox') {
            if (!service.protocol) return false;
            if (!service.host) return false;
            if (!service.port) return false;
            if (!service.attachmentLocation) return false;
            if (!service.username) return false;
        }
        if (type === 'directory') {
            if (!service.directory) return false;
        }
        return true;
    }

    savePollerService = () => {
        this.setState({ submitted: true });
        if (!this.isFormValid()) return;
        try {
            if (this.props.type == 'mailbox') {

                var bdy = {};

                bdy.id = this.props.destination;
                bdy.name = this.state.service.name;
                bdy.documentType = this.state.service.documentType;
                bdy.protocol = this.state.service.protocol;
                bdy.host = this.state.service.host;
                bdy.port = this.state.service.port;
                bdy.ignoreTLS = this.state.service.ignoreTLS;
                bdy.username = this.state.service.username;
                bdy.password = this.state.service.password;
                bdy.attachmentLocation = this.state.service.attachmentLocation;
                bdy.useSSL = this.state.service.useSSL;
                bdy.status = this.state.service.startPoller;
                bdy.description = this.state.service.description;
                bdy.includesTags = this.state.service.documentWithTags;
                bdy.type = this.props.type;
                bdy.folder = this.state.service.folder;

                this.setState({
                    isLoading: true
                });

                fetch('/api/poller/inbox', {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(bdy)
                })
                    .then(res => res.json())
                    .then(result => {
                        this.setState({
                            isLoading: false
                        });

                        if (result.error) {
                            this.setState({
                                errorMessage: result.error
                            })
                        } else {
                            this.props.alert.success("Updated mailbox poller.")
                            this.props.toggle();
                            this.props.refresh();
                        }
                    })
            }
            else if (this.props.type == 'directory') {
                var bdy = {};

                bdy.id = this.props.destination;
                bdy.name = this.state.service.name;
                bdy.documentType = this.state.service.documentType;
                bdy.directory = this.state.service.directory;
                bdy.folder = this.state.service.folder;
                bdy.status = this.state.service.startPoller;
                bdy.description = this.state.service.description;
                bdy.includesTags = this.state.service.documentWithTags;
                bdy.type = this.props.type;

                this.setState({
                    isLoading: true
                });

                fetch('/api/poller/directory', {
                    method: "PUT",
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(bdy)
                })
                    .then(res => res.json())
                    .then(result => {
                        this.setState({
                            isLoading: false
                        });

                        if (result.error) {
                            this.setState({
                                errorMessage: result.error
                            })
                        } else {
                            this.props.alert.success("Updated directory poller.")
                            this.props.toggle();
                            this.props.refresh();
                        }
                    })
            }

        } catch (err) {
            this.setState({
                errorMessage: err.message,
                isLoading: true
            });
        }
    }

    handleTextChange = (valid, e) => {
        const target = e.target;
        const value = target.value;
        const name = target.id;
        let service = { ...this.state.service };
        service[name] = value;

        this.setState({
            service
        });
    }

    handlePasswordChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let service = { ...this.state.service };
        service[name] = value;

        this.setState({
            service
        });
    }

    handleDropDownChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let service = { ...this.state.service };
        service[name] = value;

        this.setState({
            service,
            folder: value
        });
    }

    handleCheckChange = (e) => {
        const target = e.target;
        const value = target.checked;
        const name = target.name;
        let service = { ...this.state.service };
        service[name] = value;

        this.setState({
            service
        });
    }

    handlePasswordChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        let service = { ...this.state.service };
        service[name] = value;

        this.setState({
            service
        });
    }

    getDocumentTypes = () => {
        fetch('/api/configuration/documentTypes')
            .then(res => res.json())
            .then(result => {
                this.setState({
                    documentTypes: result
                })
            })
    }

    getX3Folders = async () => {
        try {
            const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
                headers: { "Accept": "application/json" }
            });

            const payload = await r.json();

            if (!r.ok) {
                console.error("get_X3_folders failed", payload);
                this.setState({ isLoading: false });
                return;
            }

            this.setState({
                folders: payload?.folders ?? [],
                isLoading: false
            });
        } catch (err) {
            console.error("get_X3_folders error", err);
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { localisation } = this.props.userReducer;
        const { submitted, service } = this.state;
        let alert_message = <div />
        let doc_types = [];
        let folders = [];
        let loading = <div />

        const reqLabel = (text) => (
            <span>{text} <span style={{ color: 'red' }}>*</span></span>
        );
        const dropdownInvalid = (value) => submitted && !value;
        const invalidStyle = { borderColor: '#eb2329' };
        const feedbackStyle = { color: '#eb2329', fontSize: '14px', display: 'block' };

        this.state.service.type = this.props.type;

        if (this.state.errorMessage)
            alert_message = <Alert color="danger">
                {this.state.errorMessage}
            </Alert>

        this.state.folders.forEach(res => {
            folders.push(<option>{res.DOSSIER}</option>)
        });

        this.state.documentTypes.forEach(docType => {
            doc_types.push(<option value={docType.DocumentType}>{docType.Description.en}</option>)
        });


        return (
            <Modal isOpen={this.props.visible} toggle={this.props.toggle} className='modal-dialog' >
                <ModalHeader toggle={this.props.toggle}>{localisation['edit_polling_sesrvice_header'] ? localisation['edit_polling_sesrvice_header'].element_lang : 'Edit Polling Service'}</ModalHeader>
                <ModalBody>
                    {this.state.service &&
                        <div>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="name"
                                    labelText={reqLabel(localisation['poller_name_text'] ? localisation['poller_name_text'].element_lang : 'Name')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.name}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="description"
                                    labelText={reqLabel(localisation['table_header_desc'] ? localisation['table_header_desc'].element_lang : 'Description')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.description}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="folder" className="s-field-title s-anchored">{localisation['table_header_folder'] ? localisation['table_header_folder'].element_lang : ''}</Label>
                                <Input type="select" disabled name={"folder"} value={this.state.service.folder} onChange={this.handleDropDownChange} id={"folder"}>
                                    {folders}
                                </Input>
                            </FormGroup>
                            <FormGroup>
                                <Label for="documentType" id="lblDocType" className="s-field-title s-anchored">{localisation['document_type_text'] ? localisation['document_type_text'].element_lang : 'Document Type'}</Label>
                                <UncontrolledTooltip placement="right" target="lblDocType">Default document type for documents which don't contain tags.</UncontrolledTooltip>
                                <Input type="select" disabled name={"documentType"} value={this.state.service.documentType} onChange={this.handleDropDownChange} id={"documentType"}>
                                    <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
                                    {doc_types}
                                </Input>
                            </FormGroup>
                        </div>
                    }
                    {this.props.type == 'mailbox' &&
                        <>
                            <FormGroup>
                                <Label for="protocol" className="s-field-title s-anchored">{reqLabel(localisation['protocol_text'] ? localisation['protocol_text'].element_lang : 'Protocol')}</Label>
                                <Input type="select" name={"protocol"} value={this.state.service.protocol} onChange={this.handleDropDownChange} style={dropdownInvalid(service.protocol) ? invalidStyle : {}}>
                                    <option value="">{localisation['default_select_text'] ? localisation['default_select_text'].element_lang : 'Select ...'}</option>
                                    <option value={"imap"}>IMAP</option>
                                    <option value={"Exchange"}>Exchange</option>
                                    <option value={"pop3"}>POP3</option>
                                </Input>
                                {dropdownInvalid(service.protocol) && <span style={feedbackStyle}>Please select a Protocol</span>}
                            </FormGroup>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="host"
                                    labelText={reqLabel(localisation['table_header_host'] ? localisation['table_header_host'].element_lang : 'Host Address')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.host}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="port"
                                    labelText={reqLabel(localisation['table_header_port'] ? localisation['table_header_port'].element_lang : 'Port Number')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.port}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="attachmentLocation"
                                    labelText={reqLabel(localisation['table_header_attachment_location'] ? localisation['table_header_attachment_location'].element_lang : 'Attachment Location')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.attachmentLocation}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="username"
                                    labelText={reqLabel(localisation['table_header_username'] ? localisation['table_header_username'].element_lang : 'username')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.username}
                                    submitted={submitted}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for={"password"}>{"Password"}</Label>
                                <Input type="password" name={"password"} autoComplete="false" onChange={this.handlePasswordChange} />
                            </FormGroup>
                            <FormGroup check style={{ marginTop: '0px' }}>
                                <Label for="field_description" className="s-field-title s-anchored">
                                    <Input type="checkbox" name={'ignoreTLS'} checked={this.state.service.ignoreTLS} onClick={this.handleCheckChange} />{' '}
                                    Ignore TLS
                                </Label>
                            </FormGroup>
                            <FormGroup check style={{ marginTop: '0px' }}>
                                <Label for="field_description" className="s-field-title s-anchored">
                                    <Input type="checkbox" name={'useSSL'} checked={this.state.service.useSSL} onClick={this.handleCheckChange} />{' '}
                                    Use SSL
                                </Label>
                            </FormGroup>
                        </>
                    }
                    {this.props.type == 'directory' &&
                        <>
                            <FormGroup>
                                <ValidatedTextBox
                                    isEnabled={true}
                                    id="directory"
                                    labelText={reqLabel(localisation['table_header_directory'] ? localisation['table_header_directory'].element_lang : 'Directory Location')}
                                    onChange={this.handleTextChange}
                                    mandatory={true}
                                    value={this.state.service.directory}
                                    submitted={submitted}
                                />
                            </FormGroup>
                        </>
                    }
                    <FormGroup check style={{ marginTop: '0px' }}>
                        <Label check className="s-field-title s-anchored">
                            <Input type="checkbox" onChange={this.handleCheckChange} checked={this.state.service.includesTags} name={'documentWithTags'} />{' '}
                            Document includes tags
                        </Label>
                    </FormGroup>
                    <br />
                    {alert_message}
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.savePollerService}>
                        {this.state.isLoading ?
                            <CircularProgress style={{ width: '1.2rem', height: '1.2rem', borderWidth: '.1em' }} />
                            :
                            localisation['save_button'] ? localisation['save_button'].element_lang : ''}
                    </Button>
                    <Button color="secondary" onClick={this.props.toggle}>{localisation['cancel_button'] ? localisation['cancel_button'].element_lang : ''}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(state => state)(withAlert()(EditPollingServiceModal));